import type { ComputedRef, InjectionKey } from 'vue';

export type NumberThousandsSeparator = 'dot' | 'comma';

export const numberThousandsSeparatorKey: InjectionKey<ComputedRef<NumberThousandsSeparator>> = Symbol('numberThousandsSeparator');

export function formatNumber(value: unknown, separator: NumberThousandsSeparator) {
  if (value === null || value === undefined || value === '') return '';
  const number = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(number)) return String(value);
  return new Intl.NumberFormat(separator === 'dot' ? 'de-DE' : 'en-US', { useGrouping: true, maximumFractionDigits: 20 }).format(number);
}

export function editableNumber(value: unknown, separator: NumberThousandsSeparator) {
  if (value === null || value === undefined || value === '') return '';
  const number = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(number)) return String(value);
  return String(number).replace('.', separator === 'dot' ? ',' : '.');
}

export function parseFormattedNumber(value: string, separator: NumberThousandsSeparator) {
  const trimmed = value.trim();
  if (!trimmed) return null;
  const grouping = separator === 'dot' ? '.' : ',';
  const decimal = separator === 'dot' ? ',' : '.';
  const normalized = trimmed.replace(/[\s']/g, '').split(grouping).join('').replace(decimal, '.');
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(normalized)) return undefined;
  const number = Number(normalized);
  return Number.isFinite(number) ? number : undefined;
}
